export default function Header() {

    return (
        <div className="in-page__hero">
            <div>
                <div className="page-bg after:bg-advertisers-hero">
                    <h1 className="hero__title">Advertisers</h1>
                    <p className="section-desc white">Pixad offers advertisers the opportunity to reach their target audience more accurately, while providing publishers with the chance to increase their advertising revenues.</p>
                </div>
            </div>
        </div>
    )
}